<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
            <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                  <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>Executive </label>
                        <multiselect
                            v-model="GlobalEmployee"
                            :options="employee_master"
                            :allow-empty="true"
                            open-direction="bottom"
                            deselect-label="Can't remove this value"
                            :custom-label="customLabel"
                            :show-labels="false"
                            track-by="EMPLOYEE_ID"
                            :close-on-select="true"
                            aria-required="true">
                        </multiselect>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>Bank </label>
                        <multiselect
                            v-model="GlobalBank"
                            :options="bank_master"
                            :allow-empty="true"
                            open-direction="bottom"
                            deselect-label="Can't remove this value"
                            track-by="BANK_ID"
                            label = "Bank_Name"
                            :close-on-select="true"
                            :show-labels="false"
                            @input="afterBankSelect"
                            aria-required="true">
                        </multiselect>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>Branch Code</label>
                        <multiselect
                            v-model="GlobalBankBranch"
                            :options="Bank_Branch_Master_For_Bank"
                            :allow-empty="true"
                            open-direction="bottom"
                            deselect-label="Can't remove this value"
                            track-by="BANK_BRACH_ID"
                            label = "Bank_Branch_Code"
                            :close-on-select="true"
                            :show-labels="false"
                            aria-required="true">
                        </multiselect>
                    </div>
                </div>

                <div class="col-md-2">
                    <div class="form-group">
                        <label> Product </label>
                        <multiselect
                            v-model="GlobalProduct"
                            :options="Product_Master_For_Bank"
                            :allow-empty="true"
                            open-direction="bottom"
                            deselect-label="Can't remove this value"
                            track-by="PRODUCT_ID"
                            label = "Product_Name"
                            :close-on-select="true"
                            :show-labels="false"
                            aria-required="true">
                        </multiselect>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>Allocated Start Date </label>
                        <input type="date" v-model="startDate"/>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="form-group">
                        <label>Allocated End Date </label>
                        <input type="date" v-model="endDate"/>
                    </div>
                </div>
                <div class="col-md-4" v-if="userglobaldata.User_Status == 'SuperAdmin'">
                    <div class="form-group">
                        <label> Admins  </label>
                        <multiselect
                            v-model="GlobalAdmin"
                            :options="Admin_Master"
                            :allow-empty="true"
                            open-direction="bottom"
                            deselect-label="Can't remove this value"
                            track-by="id"
                            label = "name"
                            :show-labels="false"
                            :close-on-select="true"
                            aria-required="true">
                        </multiselect>
                    </div>
                </div>
                <div class="col-md-1 col-xs-2 column bt-column2">
                    <div class="form-group">
                        <button class="btn btn-success" @click="loadAndSearchClientForAssignedList(1)">Submit</button>
                    </div>
                </div>

              </div>
            </div>
            </div>
            </div>
        </div>
        <div class="row mt-5">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Allocated List Total:-{{ AllocatedTotalCount }}</h3>

                <div class="card-tools">
                    <input class="btn search_box" type="text" placeholder="LoginId/Applicant" @keyup="searchit" v-model="search" aria-label="Search">
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                        <tr>
                            <th>Login Id</th>
                            <th>Bank Name</th>
                            <th>Branch Code</th>
                            <th>Product Name</th>
                            <th>Applicant Name</th>
                            <th>Executive</th>
                            <th>Location Type</th>
                            <th>Address</th>
                            <th>Mobile Number</th>
                            <th>Created At</th>
                            <th>Allocated At</th>
                        </tr>
                        <tr v-for="(client_master) in client_masters.data" :key="client_master.ECV_ID">
                            <td> {{ client_master.Login_Id}} </td>
                            <td> {{ client_master.Bank_Name}} </td>
                            <td> {{ client_master.Bank_Branch_Code}} </td>
                            <td> {{ client_master.Product_Name}} </td>
                            <td> {{ client_master.Applicant_Name}} </td>
                            <td> {{ client_master.Employee_First_Name}} {{ client_master.Employee_Last_Name}} ({{ client_master.Employee_User_Id}})</td>
                            <td> {{ client_master.Location_Type}} </td>
                            <td v-if="client_master.Location_Type == 'RV'"> {{ client_master.Residential_Address}} </td>
                            <td v-if="client_master.Location_Type == 'RV'"> {{ client_master.Contact_Person_Mobile_Number}} </td>
                            <td v-if="client_master.Location_Type == 'BV'"> {{ client_master.Office_Address}} </td>
                            <td v-if="client_master.Location_Type == 'BV'"> {{ client_master.Office_Mobile_Number}} </td>
                            <td> {{ customDateFormatter(client_master.created_at) }} </td>
                            <td> {{ customDateFormatter(client_master.AssignDate) }} </td>
                            <td>
                                <a href="#" @click="editEmployeeallocationModel(client_master.ECV_ID,client_master.EMPLOYEE_ID)"><i class="fas fa-user"></i></a>
                            </td>
                        </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-md-9">
                                    <pagination :data="client_masters" @pagination-change-page="loadAndSearchClientForAssignedList" :limit="this.$PaginationCounterLimit">
                                    <span slot="prev-nav">&lt; Previous</span>
                                    <span slot="next-nav">Next &gt;</span>
                                </pagination>
                            </div>
                            <div class="col-md-1 show-text">
                                Show
                            </div>
                            <div class="col-md-1 pagination">
                                <multiselect
                                    v-model="$PaginationLimit"
                                    :options="this.$PaginationOptions"
                                    :allow-empty="false"
                                    open-direction="top"
                                    :show-labels="false"
                                    @input="loadAndSearchClientForAssignedList(1)"
                                    aria-required="true">
                                </multiselect>
                            </div>
                            <div class="col-md-1 entries-text">
                                Entries
                            </div>
                        </div>
                    </div>
                    </div>
                    <!-- /.card -->
                    <!-- Modal -->
                <div class="modal fade" id="EditEmployeeAllocationModel" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Edit</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form @submit.prevent="editEmployeeallocation()" @keydown="form.onKeydown($event)">

                            <div class="form-group">
                                <label>Select Executive</label>
                                <multiselect
                                        :allow-empty="false"
                                        v-model="EditEmployee"
                                        :options="employee_master"
                                        :custom-label="customLabel"
                                        :searchable="true"
                                        :close-on-select="true"
                                        :show-labels="false"
                                        placeholder="Pick a value">
                                </multiselect>
                            </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                        <button type="submit" class="btn btn-primary">Save</button>
                    </div>
                    </form>
                    </div>
                </div>
                </div>
        <!--end Model-->
                </div>
                </div><!-- /.row -->
    </div>
</template>

<script>
    import Toastselectedlet from "../widget/toast";
    export default {
        props : ['userglobaldata'],
        components: { Multiselect,Toastselectedlet },
        data(){
            return{
                GlobalAdmin:'',
                Admin_Master:[],
                Product_Master_For_Bank:[],
                Bank_Branch_Master_For_Bank:[],
                toast: new Vue(),
                search:'',
                startDate:'',
                endDate:'',
                GlobalProduct:'',
                GlobalEmployee:'',
                GlobalBankBranch:'',
                GlobalBank:'',
                bank_master:[],
                employee_master:[],
                product_master:[],
                client_masters:{},
                bank_branch_master:[],
                EditEmployee:'',
                tempECV_ID:'',
                AllocatedTotalCount:'',
            }
        },
        created() {
            Fire.$on('searching',()=>{
                this.loadAndSearchClientForAssignedList();
            })
            Fire.$on('AfterChangeClient',()=>{
                this.loadAndSearchClientForAssignedList();
            });
        },
        mounted(){
            this.loadEmployee()
            this.loadBank()
            this.loadAllProduct()
            this.loadBankBranch()
            this.loadAndSearchClientForAssignedList()
            this.loadAdmins();
        },
        methods:{
            searchit: _.debounce(()=>{
                Fire.$emit('searching');
            },500),
            customLabel(option) {
                return `${option.Employee_First_Name} ${option.Employee_Last_Name}(${option.Employee_User_Id})`
            },
            loadAdmins(){
                axios.get('/loadAdmins')
                .then(({data})=> {this.Admin_Master = data})
                .catch(() => {
                    this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                });
            },
            editEmployeeallocationModel(id,E_id)
            {
                this.EditEmployee='';
                this.tempECV_ID = id;
                $('#EditEmployeeAllocationModel').modal('show')
            },
            editEmployeeallocation(){
                axios.post('/editEmployeeallocation',{
                    ecv: this.tempECV_ID,
                    employee_id: this.EditEmployee.EMPLOYEE_ID
                })
                .then(({data})=>{
                    this.loadAndSearchClientForAssignedList()
                    $('#EditEmployeeAllocationModel').modal('hide')
                }).catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                    });
            },
            afterselect_bank()
            {
                axios.get('/afterselect_bank/'+ this.GlobalBank.BANK_ID)
                    .then(({data})=> {this.Bank_Branch_Master_For_Bank = data})
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                    });
            },
            afterBankSelect(){
                this.afterselect_bank()
                axios.get('/loadProductBankWise/'+ this.GlobalBank.BANK_ID)
                    .then(({data})=> {this.Product_Master_For_Bank = data})
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                    });
            },
            loadBankBranch(){
                axios.get('/loadBankBranch')
                .then(({data})=> {this.bank_branch_master = data})
                .catch(() => {
                    this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                });
            },
            loadEmployee(){
                axios.get('/loadEmployee')
                .then(({data})=> {this.employee_master = data})
                .catch(() => {
                    this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                });
            },
            loadBank(){
                axios.get('/loadBank')
                .then(({data})=> {this.bank_master = data})
                .catch(() => {
                    this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                });
            },
            loadAllProduct(){
                axios.get('/loadAllProduct')
                    .then(({data})=> {this.product_master = data})
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any data");
                    });
            },
            loadAndSearchClientForAssignedList(page = 1) {
                var productid,bankid,employeeid,bankBranchId,AdminId;
                if(this.GlobalAdmin == null ){ AdminId = "undefined"; } else { AdminId = this.GlobalAdmin.id }
                if(this.GlobalProduct == null ){ productid = "undefined"; } else { productid = this.GlobalProduct.PRODUCT_ID }
                if(this.GlobalBank == null ){ bankid = "undefined";} else { bankid = this.GlobalBank.BANK_ID }
                if(this.GlobalEmployee == null ){ employeeid = "undefined";} else { employeeid = this.GlobalEmployee.EMPLOYEE_ID }
                if(this.GlobalBankBranch == null )
                {
                    bankBranchId = "undefined";
                } else {bankBranchId = this.GlobalBankBranch.BANK_BRANCH_ID }
                this.toast.$emit('ProgressBarLoading');
                axios
                    .get("loadAndSearchClientForAssignedList?query=" + this.search +"&bankBranchId="+ bankBranchId +"&adminId="+AdminId+"&page=" + page + "&PaginationLimit="+ this.$PaginationLimit + "&startDate="+ this.startDate + "&endDate="+ this.endDate + "&bankId="+ bankid + "&productId="+ productid + "&employeeid="+ employeeid)
                    .then(({ data }) => {
                        this.client_masters = data,
                        this.AllocatedTotalCount = data.total,
                        this.toast.$emit('ProgressBarFinish')
                    })
                    .catch(() => {
                        this.toast.$emit('ProgressBarFailerror',"Cannot Find Any Such User");
                    });
            },
        }
    }
</script>
